import { usePhotoUrl } from '../lib/photos';
import { FileOpenLink } from './FileOpenLink';

/** A square photo thumbnail from a storage path (local copy while it's still uploading). */
export function PhotoThumb({ path, size = 76, onRemove, bucket = 'photos' }: { path: string; size?: number; onRemove?: () => void; bucket?: string }) {
  const url = usePhotoUrl(path, bucket);
  return (
    <div style={{ position: 'relative', width: size, height: size, borderRadius: 10, overflow: 'hidden', background: 'var(--bg-elev-2)', flex: 'none' }}>
      {url ? (
        <FileOpenLink url={url} title="Photo"><img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /></FileOpenLink>
      ) : (
        <div className="muted small" style={{ display: 'grid', placeItems: 'center', height: '100%' }}>…</div>
      )}
      {onRemove && (
        <button type="button" aria-label="Remove photo" onClick={onRemove}
          style={{ position: 'absolute', top: 3, right: 3, width: 24, height: 24, borderRadius: 12, border: 'none', background: 'rgba(0,0,0,.6)', color: '#fff', cursor: 'pointer' }}>✕</button>
      )}
    </div>
  );
}
